import React, { Suspense, useEffect } from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
  useLocation,
} from "react-router-dom";
import { connect } from "react-redux";

import Spinner from "./components/UI/Spinner/Spinner";
import Layout from "./containers/Layout/Layout";

import * as actions from "./store/actions";

import PantallaCarga from "./containers/PantallaCarga/PantallaCarga";
import AnalisisDeudaCliente from "./containers/AnalisisDeudaCliente/AnalisisDeudaCliente";
import SimpleBackdrop from "./components/UI/Backdrop/Backdrop";
import Logout from "./containers/Auth/Logout/Logout";
import Cliente from "./containers/Cliente/Cliente";

import { storageToken } from "./assets/shared/sessionData";
import { paginaInicial, tieneAcceso } from "./assets/shared/accesos";
import IframePortal from "./containers/Auth/IframePortal/IframePortal";
import AnalisisDeudaProveedores from "./containers/AnalisisDeudaProveedores/AnalisisDeudaProveedores";
import Proveedor from "./containers/Proveedor/Proveedor";
import Impresion from "./containers/Impresion/Impresion";
import Pedidos from "./containers/Pedidos/Pedidos";
import Proximamente from "./components/UI/Proximamente/Proximamente";
import SmartScan from "./containers/SmartScan/SmartScan";

const SinAcceso = () => (
  <div style={{ padding: "40px", textAlign: "center" }}>
    Su perfil no tiene acceso a ninguna sección de Analytics.
  </div>
);

const App = (props) => {
  const {
    onTryAuthSignin,
    login,
    token,
    loadingAuth,
    loadingIndicadoresOcultos,
    loadingCambiarEmpresa,
    loadingCambiarMoneda,
    loadingExecuteCambiarAjustaPorInflacion,
  } = props;

  const { pathname, search } = useLocation();

  useEffect(() => {    
    if (storageToken()) {
      onTryAuthSignin();
    }
  }, [onTryAuthSignin, storageToken]);

  useEffect(() => {
    if (!storageToken()) {
      login(search.slice(1));
    }
  }, [login, search, storageToken]);

  let routes = (
    <Switch>
      <Route path="/" component={PantallaCarga} />
    </Switch>
  );

  if (token !== null && !loadingAuth){
    // Cada página se habilita según las secciones de Analytics del perfil del usuario (ver pagesInfo).
    const inicio = paginaInicial();
    routes = (
      <Switch>
        <Route exact path="/logout" component={Logout} />
        {tieneAcceso("analisisDeudaAcreedores") && <Route exact path="/analisisDeudaProveedor" render={(props) => <AnalisisDeudaProveedores {...props} />} />}
        {tieneAcceso("analisisDeuda") && <Route exact path="/analisisDeudaCliente" render={(props) => <AnalisisDeudaCliente {...props} />} />}
        {tieneAcceso("analisisDeuda") && <Route exact path="/cliente/:id" render={(props) => <Cliente {...props} />} />}
        {tieneAcceso("analisisDeudaAcreedores") && <Route exact path="/proveedor/:id" render={(props) => <Proveedor {...props} />} />}
        {/* La sección 46 (impresion) tiene una página por circuito: ventas (V) y compras (C) */}
        {tieneAcceso("impresion") && <Route exact path="/impresion/ventas" render={(props) => <Impresion key="V" origen="V" {...props} />} />}
        {tieneAcceso("impresion") && <Route exact path="/impresion/compras" render={(props) => <Impresion key="C" origen="C" {...props} />} />}
        {tieneAcceso("impresion") && <Redirect exact from="/impresion" to="/impresion/ventas" />}
        {tieneAcceso("impresionPedidos") && <Route exact path="/pedidos" render={(props) => <Pedidos {...props} />} />}
        {tieneAcceso("impresionPresupuestos") && <Route exact path="/presupuestos" render={() => <Proximamente titulo="Presupuestos" />} />}
        {tieneAcceso("impresionCotizaciones") && <Route exact path="/cotizaciones" render={() => <Proximamente titulo="Cotizaciones" />} />}
        {tieneAcceso("impresionOrdenesCompra") && <Route exact path="/ordenesCompra" render={() => <Proximamente titulo="Órdenes de compra" />} />}
        {tieneAcceso("smartScan") && <Route exact path="/smartScan" render={(props) => <SmartScan {...props} />} />}
        {inicio ? <Redirect push to={inicio} /> : <Route component={SinAcceso} />}
      </Switch>
    );
  }

  const loadingIndicadoresOcultosWithHome =
    (pathname === "/analisisDeudaCliente" || pathname === "") &&
    loadingIndicadoresOcultos;

  return (
    <div>
      <Suspense fallback={<Spinner />}>
        <Layout>
          <SimpleBackdrop
            open={
              loadingCambiarEmpresa ||
              loadingCambiarMoneda ||
              loadingExecuteCambiarAjustaPorInflacion ||
              loadingIndicadoresOcultosWithHome
            }
          />
          {routes}
        </Layout>
        <IframePortal />
      </Suspense>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    loadingAuth: state.auth.loading,
    loadingCambiarEmpresa: state.multiempresa.loadingCambiarEmpresa,
    loadingCambiarMoneda: state.moneda.loadingCambiarMoneda,
    loadingExecuteCambiarAjustaPorInflacion: state.configuraciones.executeCambiarAjustaPorInflacion,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAuthSignin: () => dispatch(actions.authCheckState()),
    login: (token) => dispatch(actions.login(token)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
